var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoredondo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288.669,
    height: 196.641,
    viewBox: "0 0 288.669 196.641",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11",
    transform: "translate(-178.444 -97.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M277.427,91.694h-11.3v76.363H288.73V127.815l30.513,41.611L349.35,128.2v69.636l23.614.814V91.694H347.452l-28,44.207L290.366,91.694Z",
    transform: "translate(0 6)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M464.9,229.832c-6.4,6.377-20.108,9.908-38.976,11.433,6.109.649,22.036.652,17.915,3.777-18.054,13.691-106.971,8.347-166.374-10.178-64.572-20.136-67.761-49.078-48.8-57.75,23.8-10.884,75.588-6.857,83.417-6.277-3.285,1.66-8.264,1.84-9.842,4.95,13.142-4.127,26.526-4.883,40.015-4.158-28.211-4.867-64.339-5.851-89.116-4.661-44.119,2.121-62.2,27.807-42.267,49.248,63.964,68.794,280.388,51.1,254.025,13.616",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M232.212,204.713C214.779,188.674,237.237,171,286.7,172.339c-53.249,2.9-64,16.886-54.487,32.374",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M288.6,172.257l-22.476.97v22.827H288.6Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M399.333,259.187a49.56,49.56,0,0,1-47.264,35.148H302.7V253.484c7.505,1.447,15.126,2.64,22.767,3.594v18.55h26.553a26.639,26.639,0,0,0,24.156-15.566c8-.048,15.759-.346,23.156-.875M302.7,189.882h49.368a49.513,49.513,0,0,1,49.369,49.369v5.716a49.366,49.366,0,0,1-.293,5.342c-7.049-.014-14.641-.3-22.577-.85,0-.128.005-.255.005-.383V236.8a26.63,26.63,0,0,0-26.552-26.552H325.468v32.4c-7.7-1.429-15.336-3.048-22.767-4.841Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M222.733,170.07c-102.329,23.961-3.74,79.11,59.242,89.383-111.887-37.26-99.511-77.472-59.242-89.383",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoredondo);
export default __webpack_public_path__ + "static/media/logoredondo.12be30659c644348859d4d1f20cf3bc8.svg";
export { ForwardRef as ReactComponent };